import PropTypes from "prop-types";
import React from "react";
import { useOrderScanStart } from "hooks/order-scan/useOrderScan";
import { Button } from "reactstrap";
import "./StartEndScanOrder.scss";

const StartEndScanOrder = ({
  isSendOrder,
  showStartButton = false,
  onScanStartSuccess,
  allowedGroupToTransfer,
  hubDeliver,
  hubId,
}) => {
  const { mutate: mutateOrderScanStart, isLoading: isLoadingScanStart } =
    useOrderScanStart({
      onSuccess: onScanStartSuccess,
      onError: () => {},
    });

  if (!showStartButton) {
    return null;
  }

  return (
    <div className="">
      <Button
        type="button"
        color="success"
        disabled={isLoadingScanStart}
        className="me-2 btn-label"
        onClick={() => {
          mutateOrderScanStart({
            isSendOrder,
            allowed_group_to_transfer: allowedGroupToTransfer ? 1 : 0,
            hub_id: hubId,
            from_hub: allowedGroupToTransfer ? hubDeliver.from : undefined,
            to_hub: allowedGroupToTransfer ? hubDeliver.to : undefined,
          });
        }}
      >
        <i
          className="bx bx-play-circle label-icon"
          style={{ fontSize: "31px" }}
        />
        Bắt đầu
      </Button>
    </div>
  );
};

StartEndScanOrder.propTypes = {
  isSendOrder: PropTypes.any,
  showStartButton: PropTypes.bool,
  onScanStartSuccess: PropTypes.func,
  allowedGroupToTransfer: PropTypes.any,
  hubDeliver: PropTypes.any,
  hubId: PropTypes.any,
};

export default StartEndScanOrder;
